module.exports = __webpack_public_path__ + "static/img/COC2021-17.7f12831.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting/COC2021-17.jpg
// module id = ua14
// module chunks = 0